/**
 * CetusEd Community Portal — Loading Spinner
 *
 * COMPLIANCE: Indicates a loading state to the user. Uses aria-busy="true"
 *   to communicate state to assistive technology per WCAG 2.1 AA SC 4.1.3.
 */

import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  label = 'Loading...',
}) => {
  return (
    <div
      className={`community-spinner community-spinner--${size}`}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      <div className="spinner-circle" />
      <span className="sr-only">{label}</span>
    </div>
  );
};
